module.exports = __webpack_public_path__ + "static/media/planetLogo.9cf5d8d7.svg";